
import { SWRConfiguration, SWRResponse } from "swr";

import { GetSourceDataNotApplicableAudit, GetSourceDataNotApplicableAuditResponse, GetTrialSourceDataFindings } from "@/api/dtos";
import useGet from "@/hooks/api/useGet";
import { useMemo } from "react";

const getData = (response?: SWRResponse<GetSourceDataNotApplicableAuditResponse, GetSourceDataNotApplicableAuditResponse>) => response?.data?.audit;
const getError = (response?: SWRResponse<GetSourceDataNotApplicableAuditResponse, GetSourceDataNotApplicableAuditResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetSourceDataNotApplicableAuditResponse, GetSourceDataNotApplicableAuditResponse>) => ({});

export const useParticipantSourceDataNotApplicableAudit = (
    trialId?: number,
    participantId?: number,
    studyEventOid?: string,
    studyEventRepeat?: number,
    caseReportFormOid?: string,
    itemGroupName?: string,
    itemGroupRepeat?: number,
    itemName?: string,
    configuration?: SWRConfiguration | undefined
) => {
    const request = useMemo(() => {
        if (
            !trialId || 
            !participantId || 
            !studyEventOid || 
            !studyEventRepeat || 
            !caseReportFormOid || 
            !itemName
        ) {
            return undefined;
        }

        return () => {
            return new GetSourceDataNotApplicableAudit({ 
                trialId,
                participantId,
                studyEventOid,
                studyEventRepeat,
                caseReportFormOid,
                itemGroupName,
                itemGroupRepeat: itemGroupRepeat ?? 1,
                itemName
            });
        }
    }, [
        trialId,
        participantId,
        studyEventOid,
        studyEventRepeat,
        caseReportFormOid,
        itemGroupName,
        itemGroupRepeat,
        itemName
    ]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useParticipantSourceDataNotApplicableAudit;